import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services';
import { ContractService } from 'src/app/services/contract.service';
import { ServiceModuleService } from 'src/app/services/service.service';
import { ToastService } from 'src/app/services/toast.service';
import { PendingStatusEnum, SignalingImageSituationEnum } from 'src/enumerators';
import { Contract, ContractServiceItem } from 'src/models';
import { ServiceModel, TypeService } from 'src/models/service';

@Component({
  selector: 'app-display-summary-service',
  templateUrl: './display-summary-service.component.html',
  styleUrls: ['./display-summary-service.component.css', '../display-summary/display-summary.component.css', '../../catalog/display-catalog/display-catalog.component.css', '../../catalog/display-sign/display-sign.component.css']
})
export class DisplaySummaryServiceComponent implements OnInit, OnChanges {
  @Input() selectedService: ServiceModel;
  @Output() approvedSign: EventEmitter<any> = new EventEmitter();

  pendingStatusEnum = PendingStatusEnum;
  contract: Contract;
  contractServiceItems: Array<ContractServiceItem> = [];
  loading = true;
  imageSituationEnum = SignalingImageSituationEnum;

  constructor(
    private _contractService: ContractService,
    private _modalService: BsModalService,
    private _router: Router,
    private _serviceService: ServiceModuleService,
    private _toastService: ToastService,
    public _authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.loading = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loading = true;
    if (changes.selectedService?.previousValue?.id != changes.selectedService?.currentValue?.id) {
      this._serviceService.getServiceId(this.selectedService.id).subscribe((res: ServiceModel) => {
        this.selectedService.files = res.files;
        this.getContract();
      })
    }
  }

  getContract() {
    this._contractService.getContract(this.selectedService.contractId).subscribe((res: Contract) => {
      this.contract = res;
      this.getContractItemNumberName()
      this.loading = false;
    })
  }

  getContractItemNumberName() {
    let find = false;
    this.selectedService.types.forEach(type => {
      this.contract.serviceGroups.some((group, indexGroup) => {
        group.serviceItems.some((item, indexItem) => {
          if (item.id == type.contractServiceItemId) {
            type['itemNumber'] = `Item ${indexGroup + 1}.${indexItem + 1}`
            type['name'] = item.name;
            find = true;
            return true;
          }
        })
        if (find) return true;
      });
    });

    // Ordena do menor pro maior grupo e item (1.1, 1.2, 2.3, 3.1...)
    this.selectedService.types.sort(function (a, b) {
      return (a['itemNumber'] < b['itemNumber'] ? -1 : a['itemNumber'] > b['itemNumber'] ? 1 : 0)
    })

  }

  updateStatus(pendingStatus: PendingStatusEnum) {
    this.selectedService.status = pendingStatus;
    this._serviceService.updateService(this.selectedService, this.selectedService.id).subscribe((res: ServiceModel) => {
      this.approvedSign.emit(res)
      this._toastService.showSuccess('O serviço foi aprovado com sucesso');
    })
  }

  getImageEmpty(situation: SignalingImageSituationEnum): boolean {
    let situationEmpty = true;
    this.selectedService?.files?.some(file => {
      if (file.situation == situation) {
        situationEmpty = false;
        return true
      }
    });
    return situationEmpty;
  }

  serviceDetailRouting(service: ServiceModel) {
    this._router.navigate([`services/list/checkout`], { queryParams: { id: service.id } });
  }
}
